<section
  class="not-found-section h-screen relative flex justify-content-center align-items-center {{
    globalStore.isDarkTheme() ? 'dark-background' : 'light-background'
  }}"
>
  <div class="not-found-block absolute">
    <div class="code-description-block text-center mb-6">
      <h1 class="code font-bold mb-2">404</h1>
      <h5 class="description text-xl font-light uppercase">Page not found</h5>
    </div>
    <div class="text-center">
      <inpla-primary-button
        styleClass="w-13rem bg-transparent"
        title="Back to Dashboard"
        icon="pi-arrow-left"
        type="secondary"
        (onClick)="navigateToMainPage()"
      />
    </div>
  </div>
</section>
